import { defineMessages } from "react-intl";

import { Tier } from "graphql_globals";

export const NOTARIZE_DOCUMENT_TITLES = defineMessages({
  default: {
    id: "7f19a718-c353-4bbe-b5e9-a28ff5a40754",
    defaultMessage: "Notarize",
  },
  // guest
  resetPassword: {
    id: "53c4b39c-888f-474c-ac5f-34ad142c84e7",
    defaultMessage: "Reset password - Notarize",
  },
  signIn: {
    id: "c238e687-55a4-484a-a925-824351bbf133",
    defaultMessage: "Sign in - Notarize",
  },
  // sign up
  [Tier.ELITE]: {
    id: "24716e72-3495-4d14-84ec-ddfe0905a869",
    defaultMessage: "Premium Plan - Notarize",
  },
  [Tier.PRO]: {
    id: "f165fc89-655b-4cba-b837-a6d7413c801d",
    defaultMessage: "Pro Plan - Notarize",
  },
  [Tier.PRO_TRIAL]: {
    id: "52e1f21e-9e94-4546-9c75-a1dda9829c33",
    defaultMessage: "Pro Trial - Notarize",
  },
  [Tier.BASIC]: {
    id: "816fa871-a8be-4535-9cf5-f93207050e2a",
    defaultMessage: "Starter Plan - Notarize",
  },
  signUpFallback: {
    id: "ecc7142f-69a3-46fb-8c83-2ab72aa97654",
    defaultMessage: "Sign up - Notarize",
  },
  // upload documents
  uploadDocumentsForNotarization: {
    id: "54321629-7d8c-4bcb-9a1b-d1e3b3b3a404",
    defaultMessage: "Upload documents for notarization - Notarize",
  },
  uploadDocumentsForEsign: {
    id: "36cd5b8e-d340-4bbb-a724-51d373743d4a",
    defaultMessage: "Upload documents for eSign - Notarize",
  },
  browserNotSupported: {
    id: "f189b471-705a-4fe3-889f-552b718b8e27",
    defaultMessage: "Browser not supported - Notarize",
  },
  // signer dashboard
  getStarted: {
    id: "07858450-d522-4a3d-be2c-89f0fb0fb76c",
    defaultMessage: "Get started - Notarize",
  },
  signerDashboard: {
    id: "f91e6c55-f4b6-423c-a92c-9c3aea10099f",
    defaultMessage: "Signer Dashboard - Notarize",
  },
  signerViewDocument: {
    id: "01fab65b-f5af-4242-9ee9-193c3daa5b6b",
    defaultMessage: "View Document - Notarize",
  },
  deleteDocument: {
    id: "d1e04933-aaa2-42ee-b1ae-763a97e89ee5",
    defaultMessage: "Delete document - Notarize",
  },
  // signer flow
  preFillInstructionsSignerSlide: {
    id: "e7509d4d-8acf-4c63-81f2-b348890e7ce8",
    defaultMessage: "Signer full name - Prepare Documents - Notarize",
  },
  primarySignerDetails: {
    id: "b74fb665-9a83-4c51-9524-737d842ae107",
    defaultMessage: "Enter your full name - Prepare Documents - Notarize",
  },
  requiredSignersTitle: {
    id: "0bbae0e9-b84a-43af-af9e-d58dde4082e4",
    defaultMessage: "Required signers - Prepare Documents - Notarize",
  },
  requiredNotTogetherTitle: {
    id: "d91d6e25-357a-4e69-b98d-7de77f3cf528",
    defaultMessage: "Not with required signers - Prepare Documents - Notarize",
  },
  multipleSignersTitle: {
    id: "9680398f-a37f-482b-b423-a32b519f98dc",
    defaultMessage: "Who is joining the meeting? - Prepare Documents - Notarize",
  },
  twoSignersTitle: {
    id: "c7bb0085-4f60-46d6-b432-9e81ba246c31",
    defaultMessage: "Are the two signers joining the meeting? - Prepare Documents - Notarize",
  },
  // esign
  bundlePrefillEsign: {
    id: "1f6c51e3-ffec-4b74-9b80-858e9db81961",
    defaultMessage: "Preview document - Prepare Documents - Notarize",
  },
  bundlePrefillEditSign: {
    id: "84fbd4ac-b52f-4d00-9bd7-93b53228cb9c",
    defaultMessage: "Edit and sign document - Prepare Documents - Notarize",
  },
  bundlePrefillReviewSign: {
    id: "701fca42-d359-4d9b-ae1a-a096f0f1eb1d",
    defaultMessage: "Review and sign document - Prepare Documents - Notarize",
  },
  bundlePrefillEditReview: {
    id: "32e48518-f2ee-48df-a50e-45826e2ce917",
    defaultMessage: "Edit and review document - Prepare Documents - Notarize",
  },
  bundlePrefillReviewDocument: {
    id: "6c2dce7a-d184-4830-b018-4758538a4450",
    defaultMessage: "Review document - Prepare Documents - Notarize",
  },
  confirmSignature: {
    id: "1d0e5f05-a68f-412d-b63d-6497e2e3415c",
    defaultMessage: "Confirm signature - Prepare Documents - Notarize",
  },
  confirmInitials: {
    id: "a9d80f97-58fc-4920-90b6-1a2e49f4230a",
    defaultMessage: "Confirm initials - Prepare Documents - Notarize",
  },
  signerEsignCompleted: {
    id: "7cc665d4-7db2-416f-a404-ce1535aac776",
    defaultMessage: "You've finished signing - Notarize",
  },
  // tech check
  twilioTechCheckIntro: {
    id: "1a51ede9-b7a1-4cd9-a1fd-dd81a218159a",
    defaultMessage: "Technology Check - Prepare Documents - Notarize",
  },
  twilioTechCheckSelection: {
    id: "7c780f7c-06ee-4ff0-8276-e97559fcb52e",
    defaultMessage: "Setup Audio and Video - Prepare Documents - Notarize",
  },
  standaloneTechCheckSetup: {
    id: "09f779c6-ca2d-47a8-bf8e-f3d8f85661f3",
    defaultMessage: "Set up audio and video - Notarize",
  },
  // customer details
  preMeetingCustomerDetailsIntro: {
    id: "c3d0f1e8-0b1a-4b8f-8f9c-8c1f8f8b0b1d",
    defaultMessage: "Next steps for ID verification - Prepare Documents - Notarize",
  },
  preMeetingCustomerDetailsPersonalDetails: {
    id: "f9507528-2a07-4c66-9bbf-51dcf463da29",
    defaultMessage: "Enter your information - Prepare Documents - Notarize",
  },
  preMeetingCustomerDetailsAddressDetails: {
    id: "e50a6450-00f5-44ab-a555-6308e60bea07",
    defaultMessage: "Enter your address - Prepare Documents - Notarize",
  },
  preMeetingIdentityQuestionsIntro: {
    id: "054f806d-07fb-43a2-904d-53284e631463",
    defaultMessage: "Identity questions intro - Prepare Documents - Notarize",
  },
  preMeetingIdentityQuestionsQuiz: {
    id: "5160e51e-34bf-499a-a925-be3bbc95a61e",
    defaultMessage: "Identity questions quiz - Prepare Documents - Notarize",
  },
  preMeetingIdentityQuestionsSuccess: {
    id: "c6eb6cbe-5b90-430c-84c2-ca6ab1f314f5",
    defaultMessage: "Passed identity questions - Prepare Documents - Notarize",
  },
  preMeetingIdentityQuestionsFailure: {
    id: "9cba6561-a73f-44b0-bf48-587255d16971",
    defaultMessage: "Failed identity questions - Prepare Documents - Notarize",
  },
  preMeetingIdentityQuestionsInfo: {
    id: "f02c51e4-915b-486c-832e-a8e84936181f",
    defaultMessage: "Unable to generate identity questions - Prepare Documents - Notarize",
  },
  preMeetingCredentialAnalysisIntro: {
    id: "faf2e900-9981-4e75-8d6d-58ee54dde571",
    defaultMessage: "Capture your ID - Prepare Documents - Notarize",
  },
  preMeetingCredentialAnalysisSecondary: {
    id: "f922f8c9-f2f1-4de1-be2a-51fb934328e5",
    defaultMessage: "Do you require a secondary ID? - Prepare Documents - Notarize",
  },
  preMeetingCredentialAnalysisPhotoIdUpload: {
    id: "5cb8495d-081a-420c-b7cb-941a7861f3ee",
    defaultMessage: "Photo ID Upload - Prepare Documents - Notarize",
  },
  preMeetingCredentialAnalysisCapture: {
    id: "0a16bb9c-a2f3-4318-bfff-e008fd46fcae",
    defaultMessage: "ID verification - Prepare Documents - Notarize",
  },
  preMeetingCredentialAnalysisFailure: {
    id: "679f30d2-0153-4602-8d6e-20f6abf9faf1",
    defaultMessage: "ID validation error - Prepare Documents - Notarize",
  },
  preMeetingCosignerCustomerDetailsIntro: {
    id: "91cb48c6-6170-4d28-949b-9293e555e597",
    defaultMessage: "Next steps for cosigner ID verification - Prepare Documents - Notarize",
  },
  preMeetingCosignerCustomerDetailsPersonalDetails: {
    id: "f41b2092-b815-4c17-8fcc-81d2b894e418",
    defaultMessage: "Enter cosigner information - Prepare Documents - Notarize",
  },
  preMeetingCosignerCustomerDetailsAddressDetails: {
    id: "931e51db-4758-48ff-baa3-47a9ac3019b7",
    defaultMessage: "Enter cosigner address - Prepare Documents - Notarize",
  },
  preMeetingCosignerIdentityQuestionsIntro: {
    id: "cbc846df-4014-4fdd-80de-c24f20fce4ae",
    defaultMessage: "Cosigner identity questions intro - Prepare Documents - Notarize",
  },
  preMeetingCosignerIdentityQuestionsQuiz: {
    id: "1d1adfa3-f11f-45bf-a4d6-20ccd481b043",
    defaultMessage: "Cosigner identity questions quiz - Prepare Documents - Notarize",
  },
  preMeetingCosignerIdentityQuestionsSuccess: {
    id: "16195520-308f-4b92-9d68-45dfc6708fb6",
    defaultMessage: "Passed cosigner identity questions - Prepare Documents - Notarize",
  },
  preMeetingCosignerIdentityQuestionsFailure: {
    id: "f69f731d-e8b9-4dec-a9b3-ea772acef339",
    defaultMessage: "Failed cosigner identity questions - Prepare Documents - Notarize",
  },
  preMeetingCosignerIdentityQuestionsInfo: {
    id: "2c42f9c5-7b75-4b2b-8829-c18dd6ccf369",
    defaultMessage: "Unable to generate cosigner identity questions - Prepare Documents - Notarize",
  },
  preMeetingCosignerCredentialAnalysisIntro: {
    id: "703491c8-72d5-4dbb-a7e7-be13d9ffe40f",
    defaultMessage: "Capture cosigner's ID - Prepare Documents - Notarize",
  },
  preMeetingCosignerCredentialAnalysisSecondary: {
    id: "f1eeabbf-e839-4332-882b-1486e8359ed4",
    defaultMessage: "Does cosigner require a secondary ID? - Prepare Documents - Notarize",
  },
  preMeetingCosignerCredentialAnalysisSecondaryCapture: {
    id: "dea6e6fc-73fa-43c3-b5e3-0fe3d4bedeff",
    defaultMessage: "Cosigner secondary ID verificaton - Prepare Documents - Notarize",
  },
  preMeetingCosignerCredentialAnalysisFailure: {
    id: "ae204806-2e48-4547-b0b7-ce255178cc1d",
    defaultMessage: "Cosigner ID validation error - Prepare Documents - Notarize",
  },
  guestMobileLink: {
    id: "50d69241-bc7e-4a18-8c62-de9bbc567544",
    defaultMessage: "Continue in the App - Prepare Document - Notarize",
  },
  requestNotaryVideoMeetingCameraRequired: {
    id: "335cc4bf-9ca7-4326-bb53-10dcbef7db8e",
    defaultMessage: "Camera access required - Prepare Documents - Notarize",
  },
  requestNotaryVideoMeeting: {
    id: "b6984656-3111-48e9-a511-d6483b1da0b2",
    defaultMessage: "Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  notaryVideoCallLobby: {
    id: "46f18d3a-dc82-46ef-bcb8-e0ac0d4deae2",
    defaultMessage:
      "Notary Video Call Lobby - Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  notaryVideoCallLobbyWaitingForOthers: {
    id: "46f18d3a-dc82-46ef-bcb8-e0ac0d4deae2",
    defaultMessage:
      "Waiting for a notary - Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  notaryVideoCallLobbyUnavailableNotary: {
    id: "ef3d9b32-4a8e-4d6f-9b96-f11b92e68144",
    defaultMessage:
      "No available notaries - Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  notaryVideoCallLobbyPhoneCallback: {
    id: "9e1db667-9c63-4be1-9658-4c1b844c1fcd",
    defaultMessage:
      "We apologize for the wait - Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  notaryVideoCallLobbyNsaUnavailable: {
    id: "7f3b4dab-bf41-45e2-b7bb-29eaa89fb403",
    defaultMessage:
      "Outside Notary Signing Agent hours - Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  notaryVideoCallLobbyMeetingAccepted: {
    id: "0dd79df8-79ba-429e-8d04-fa7f210343d1",
    defaultMessage:
      "Meeting accepted - Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  notaryVideoCallLobbyPhoneNotification: {
    id: "aa6d5a19-45ce-4c0a-b9f7-8808c0fb37cb",
    defaultMessage:
      "Phone notification - Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  notaryOnboarding: {
    id: "9e60c3d9-9507-4453-afe7-0ee4babbc834",
    defaultMessage: "Notary Onboarding - Notarize",
  },
  notaryVideoCallLobbyLobbyError: {
    id: "b89c6812-83a6-467a-aa93-5727ef2d3f59",
    defaultMessage:
      "Session cancelled - Request Notary Video Meeting - Prepare Documents - Notarize",
  },
  signerIdentityExpiredSession: {
    id: "7e123ad2-7e6e-4389-a84a-d4e93c9fdff4",
    defaultMessage: "Expired session - Prepare Documents - Notarize",
  },
  errorBoundary: {
    id: "f5eac117-d850-4934-80b7-72f1127ac13c",
    defaultMessage: "Something went wrong - Notarize",
  },
  meeting: {
    id: "9d5d8378-27ea-48cb-8d2e-d472577baf83",
    defaultMessage: "Meeting - Notarize",
  },
  meetingCompletePaymentFailed: {
    id: "e6d0fa5e-233c-4399-aed6-597450440168",
    defaultMessage: "Payment Failed - Notarize",
  },
  meetingCompleteSetupPayment: {
    id: "428305dc-ee2d-4abf-a295-16f0dc936239",
    defaultMessage: "Setup Payment - Notarization Complete - Notarize",
  },
  meetingCompleteShareDocuments: {
    id: "bc087d04-3c63-4548-a0e7-fb8feb7def9c",
    defaultMessage: "Share Documents - Notarization Complete - Notarize",
  },
  meetingCompleteCreatePassword: {
    id: "3e1d83af-56f4-46c8-9db3-74809ba35f16",
    defaultMessage: "Create Password - Notarization Complete - Notarize",
  },
  documentDetailsSummary: {
    id: "b83535f0-f97c-4d4d-82af-03ec119ac15d",
    defaultMessage: "Summary - Document Details - Notarize",
  },
  documentDetailsNotary: {
    id: "0d366fd9-c1e9-41db-b8f1-edb1efbf4ab5",
    defaultMessage: "Notary - Document Details - Notarize",
  },
  documentDetailsVideo: {
    id: "2daf951c-f194-4591-b06b-1826b8f1e461",
    defaultMessage: "Video - Document Details - Notarize",
  },
  documentDetailsDocument: {
    id: "908d7ba9-7820-4306-a280-9d2665e90e20",
    defaultMessage: "Document - Document Details - Notarize",
  },
  shareDocumentByEmail: {
    id: "dc357393-2329-400d-85c4-5c9e5c532f39",
    defaultMessage: "Share documents by email - Notarize",
  },
  // Settings
  settingsDefault: {
    id: "e8a8949b-32e6-4fd0-9696-b543ff89aa2d",
    defaultMessage: "Settings - Notarize",
  },
  settingsOrganizationOverview: {
    id: "af02e878-4e79-4018-a026-b0d13204f909",
    defaultMessage: "Organization Overview - Settings - Notarize",
  },
  settingsSharedInbox: {
    id: "e571df37-265c-4ba6-8484-9f90fba0d752",
    defaultMessage: "Shared inbox - Settings - Notarize",
  },
  settingsEligibility: {
    id: "42297c9b-a60d-41fc-b795-448a43094e0e",
    defaultMessage: "Eligibility - Settings - Notarize",
  },
  settingsNotaryHours: {
    id: "ed1bec06-b851-43f4-9119-22c1db214425",
    defaultMessage: "Notary hours - Settings - Notarize",
  },
  settingsBillingPlanDetails: {
    id: "c49e207b-ef5d-4786-b56c-ca6fc906b11e",
    defaultMessage: "Plan Details - Billing - Settings - Notarize",
  },
  settingsBillingPaymentSettings: {
    id: "23ba844a-fc43-4975-bf65-729e0ee1b4b7",
    defaultMessage: "Payment Settings - Billing - Settings - Notarize",
  },
  settingsBillingBillingContact: {
    id: "f00d8e9c-eabb-41af-ac7b-4ff4247caf4a",
    defaultMessage: "Billing Contact - Billing - Settings - Notarize",
  },
  settingsBillingRecentPayments: {
    id: "125072f4-2d61-42c0-ae3c-5c4f2142210b",
    defaultMessage: "Recent Payments - Billing - Settings - Notarize",
  },
  settingsTransactionsSignerSettings: {
    id: "3ada5a3e-ba6d-42c8-8b35-f2bc148c84fa",
    defaultMessage: "Signer Settings - Transactions - Settings - Notarize",
  },
  settingsTransactionsTemplateSettings: {
    id: "b4538d26-5993-4e35-936e-135122a2cdcb",
    defaultMessage: "Template Settings - Transactions - Settings - Notarize",
  },
  settingsTeamSecurity: {
    id: "79e2c47e-cb25-4aa4-aaf5-1e972c9b34d6",
    defaultMessage: "Team security - Settings - Notarize",
  },
  settingsBrandColors: {
    id: "31739d44-9aa3-4fed-b321-98463520a135",
    defaultMessage: "Brand colors - Brand Customization - Settings - Notarize",
  },
  settingsBrandLogoAndHeader: {
    id: "3ed0f4d2-1b48-41e7-872f-5e925f7975a5",
    defaultMessage: "Logo & header - Brand Customization - Settings - Notarize",
  },
  settingsWebsiteCustomization: {
    id: "bc9167dc-16bb-4a30-99b7-3dee33a390cd",
    defaultMessage: "Signer landing page - Website Customization - Settings - Notarize",
  },
  settingsIntegrations: {
    id: "ef16d381-a483-4c25-aa37-e395a6131138",
    defaultMessage: "Integrations - Settings - Notarize",
  },
  settingsApiKeys: {
    id: "0646b0bb-51ac-4fba-975f-40d40651a1ff",
    defaultMessage: "API keys - Settings - Notarize",
  },
  settingsTransactionsNotaryInstructions: {
    id: "ad0d4616-c05c-4203-b282-e4277b160756",
    defaultMessage: "Notary Instructions - Transactions - Settings - Notarize",
  },
  settingsProfileOverview: {
    id: "9798243f-bd7b-4444-a7f2-990952a5da2c",
    defaultMessage: "Profile Overview - Settings - Notarize",
  },
  settingsProfilePersonalDetails: {
    id: "c7cc3926-e170-4329-ba04-abba243673ac",
    defaultMessage: "Personal details - Profile - Settings - Notarize",
  },
  settingsProfilePersonalPayments: {
    id: "3f373ba2-06ca-4c32-aa8f-092bf88e6eea",
    defaultMessage: "Personal payment - Profile - Settings - Notarize",
  },
  settingsProfilePersonalPaymentsUpdatePayment: {
    id: "a64f7ca9-b8d4-4dbc-92d2-1aa090633929",
    defaultMessage: "Update payment method - Profile - Settings - Notarize",
  },
  settingsProfilePersonalPaymentsPaymentDetails: {
    id: "fceb4371-77a1-46de-9668-8e5f0aa2d3c6",
    defaultMessage: "Payment Detail - Profile - Settings - Notarize",
  },
  settingsTerms: {
    id: "949a0f2a-5eeb-45e9-81e3-f9055d13042c",
    defaultMessage: "Terms and conditions - Settings - Notarize",
  },
  // Settings - Notary profile
  settingsNotaryDefault: {
    id: "3e19872f-4b5c-4a09-8933-62d161d68d1c",
    defaultMessage: "Notary profile - Settings - Notarize",
  },
  settingsNotaryPersonalInfo: {
    id: "1bfb2e60-877d-4fe7-8dd2-8fa328bfa711",
    defaultMessage: "Personal info - Notary profile - Settings - Notarize",
  },
  settingsNotaryCommissionAndRonInfo: {
    id: "74d9ff5a-fe16-4f32-8269-1751b8519d39",
    defaultMessage: "Commission details - Notary profile - Settings - Notarize",
  },
  settingsNotaryInsuranceDetails: {
    id: "193f9dcc-e6f7-4420-a79f-568f7920da65",
    defaultMessage: "Insurance details - Notary profile - Settings - Notarize",
  },
  settingsNotaryDigitalCertificate: {
    id: "6d68819d-f9a7-4ed0-bc55-7fdf10ab6295",
    defaultMessage: "Digital certificate - Notary profile - Settings - Notarize",
  },
  settingsNotarySignatureAndSeal: {
    id: "7541d81f-2af6-41ba-aa43-1f2889336eac",
    defaultMessage: "Signature and seal - Notary profile - Settings - Notarize",
  },
  settingsNotaryIdentityVerification: {
    id: "b1d9e619-a0ea-4541-a9a5-c39779e3260f",
    defaultMessage: "Verify Identity - Notary profile - Settings - Notarize",
  },
  settingsNotaryProofCertificate: {
    id: "240744f3-622c-4528-8141-0b152ad90e4c",
    defaultMessage: "Proof certificate - Notary profile - Settings - Notarize",
  },
  settingsNotaryPayoutOptions: {
    id: "7be75b95-440e-4c04-ad5d-c2195c57303a",
    defaultMessage: "Payout options - Notary profile - Settings - Notarize",
  },
  settingsNotaryStateEducation: {
    id: "cd170e8d-af47-4a29-9288-be130bb7d28d",
    defaultMessage: "State education - Notary profile - Settings - Notarize",
  },
  settingsNotaryTermsOfUse: {
    id: "b3ed5af5-4e3a-44c4-aa69-b8c728c2e2a8",
    defaultMessage: "Terms - Notary profile - Settings - Notarize",
  },
  notaryJournal: {
    id: "f6866e37-1f81-41b8-9c11-813abc662c74",
    defaultMessage: "Notary journal - Notarize",
  },
  // errors
  mutationError: {
    id: "906ad88f-4d0c-4d19-8851-a5aed357e8a1",
    defaultMessage: "Something went wrong - Notarize",
  },
});

export const PROOF_DOCUMENT_TITLES = defineMessages({
  default: {
    id: "f03d6a5b-7504-4b42-a755-c3457600f9e8",
    defaultMessage: "Proof",
  },
  // guest
  guestSignupNotarization: {
    id: "90f04fd7-b3a6-41d6-8c5a-2ad6a2b0c8ac",
    defaultMessage: "Upload a document to notarize - Proof",
  },
  guestSignupEsign: {
    id: "bf431bc0-d298-4ec5-9e4c-6998f534279c",
    defaultMessage: "Upload a document to eSign - Proof",
  },
  resetPassword: {
    id: "46ca25cf-cb34-47d9-acc1-44ed8f3502c0",
    defaultMessage: "Reset password - Proof",
  },
  signIn: {
    id: "5e563132-9b1f-48b7-ac1d-76be618e85d0",
    defaultMessage: "Sign in - Proof",
  },
  // sign up
  [Tier.ELITE]: {
    id: "cb33a8a1-7728-4993-992d-672d3a7491fd",
    defaultMessage: "Premium Plan - Proof",
  },
  [Tier.PRO]: {
    id: "802bb211-08e5-48af-8bde-18d1d187226f",
    defaultMessage: "Pro Plan - Proof",
  },
  [Tier.PRO_TRIAL]: {
    id: "6d5175e0-9dbe-4e4a-8e1a-515c2619e224",
    defaultMessage: "Pro Trial - Proof",
  },
  [Tier.BASIC]: {
    id: "b1c46cb0-3024-47aa-9a1b-8fd7818be475",
    defaultMessage: "Starter Plan - Proof",
  },
  signUpFallback: {
    id: "c6095c18-3c8b-463f-87bd-3b19011b77f8",
    defaultMessage: "Sign up - Proof",
  },
  // upload documents
  uploadDocumentsForNotarization: {
    id: "9006d1ba-63f6-4762-a5df-7711d7824ee7",
    defaultMessage: "Upload documents for notarization - Proof",
  },
  uploadDocumentsForEsign: {
    id: "9baadc2b-f912-4592-8fdd-5bc9dd8845fb",
    defaultMessage: "Upload documents for eSign - Proof",
  },
  browserNotSupported: {
    id: "2f8b42e9-183b-4315-898a-f170dbc316f3",
    defaultMessage: "Browser not supported - Proof",
  },
  // signer dashboard
  getStarted: {
    id: "8d66d787-6b5b-4f1a-a56c-fc7562788a99",
    defaultMessage: "Get started - Proof",
  },
  signerDashboard: {
    id: "099a841f-be83-4d9a-afce-6b5db124d7b4",
    defaultMessage: "Signer Dashboard - Proof",
  },
  signerViewDocument: {
    id: "50d00f96-bc6d-4532-8a37-399ec6487646",
    defaultMessage: "View Document - Proof",
  },
  deleteDocument: {
    id: "096f94e6-d73c-44dc-b558-2a1cba8fd9a2",
    defaultMessage: "Delete document - Proof",
  },
  // signer flow
  preFillInstructionsSignerSlide: {
    id: "b7db9e30-365c-4905-9019-18d3fa758bc7",
    defaultMessage: "Signer full name - Prepare Documents - Proof",
  },
  primarySignerDetails: {
    id: "d96a81ad-84dd-4b1f-a073-00c7c8435f80",
    defaultMessage: "Enter your full name - Prepare Documents - Proof",
  },
  requiredSignersTitle: {
    id: "821bcaef-7662-4d71-b136-14c8042f201f",
    defaultMessage: "Required signers - Prepare Documents - Proof",
  },
  requiredNotTogetherTitle: {
    id: "bedad783-7975-4aad-8b3e-19836a4ae2bb",
    defaultMessage: "Not with required signers - Prepare Documents - Proof",
  },
  multipleSignersTitle: {
    id: "0b668fcc-8179-48bc-adb7-28ef73696cf7",
    defaultMessage: "Who is joining the meeting? - Prepare Documents - Proof",
  },
  twoSignersTitle: {
    id: "edd2278f-8ec3-40cd-ba38-f23439e82276",
    defaultMessage: "Are the two signers joining the meeting? - Prepare Documents - Proof",
  },
  // esign
  bundlePrefillEsign: {
    id: "1bf730a1-05b2-464b-abc0-9814b84c4c00",
    defaultMessage: "Preview document - Prepare Documents - Proof",
  },
  bundlePrefillEditSign: {
    id: "ea662c96-054b-4baa-a3ef-4eadd8569dad",
    defaultMessage: "Edit and sign document - Prepare Documents - Proof",
  },
  bundlePrefillReviewSign: {
    id: "1616d2e2-2c5f-4b46-92e8-37d074e41f54",
    defaultMessage: "Review and sign document - Prepare Documents - Proof",
  },
  bundlePrefillEditReview: {
    id: "7775e1c4-a224-4565-8eb0-39faf71a9903",
    defaultMessage: "Edit and review document - Prepare Documents - Proof",
  },
  bundlePrefillReviewDocument: {
    id: "62952542-8655-4e03-ac49-3b75c74a7253",
    defaultMessage: "Review document - Prepare Documents - Proof",
  },
  confirmSignature: {
    id: "09e832d9-c3bd-43cf-9920-3433f821c443",
    defaultMessage: "Confirm signature - Prepare Documents - Proof",
  },
  confirmInitials: {
    id: "f6a282f0-aa2b-4980-8965-6e89770b3842",
    defaultMessage: "Confirm initials - Prepare Documents - Proof",
  },
  signerEsignCompleted: {
    id: "7c39969e-9e95-46fb-a79d-35c1ad4c109c",
    defaultMessage: "You've finished signing - Proof",
  },
  // tech check
  twilioTechCheckIntro: {
    id: "f4af1808-3552-4c3d-be18-9fe79ae9935d",
    defaultMessage: "Technology Check - Prepare Documents - Proof",
  },
  twilioTechCheckSelection: {
    id: "c2d006f3-f54b-4308-bbf9-d9aff3e66717",
    defaultMessage: "Setup Audio and Video - Prepare Documents - Proof",
  },
  standaloneTechCheckSetup: {
    id: "2baa4b01-5133-4476-bdea-a0fda956fa02",
    defaultMessage: "Set up audio and video - Proof",
  },
  // customer details
  preMeetingCustomerDetailsIntro: {
    id: "b228fbef-a5e6-4c02-b291-b71f94fe4992",
    defaultMessage: "Next steps for ID verification - Prepare Documents - Proof",
  },
  preMeetingCustomerDetailsPersonalDetails: {
    id: "55074f0f-9987-4425-b43d-ef2864d00d57",
    defaultMessage: "Enter your information - Prepare Documents - Proof",
  },
  preMeetingCustomerDetailsAddressDetails: {
    id: "015bf441-591b-4469-8fb3-ff30695631e6",
    defaultMessage: "Enter your address - Prepare Documents - Proof",
  },
  preMeetingIdentityQuestionsIntro: {
    id: "e971170c-5151-481a-8f58-f476abc46e9b",
    defaultMessage: "Identity questions intro - Prepare Documents - Proof",
  },
  preMeetingIdentityQuestionsQuiz: {
    id: "969fb03a-33fa-4fb9-a935-999b41b0565c",
    defaultMessage: "Identity questions quiz - Prepare Documents - Proof",
  },
  preMeetingIdentityQuestionsSuccess: {
    id: "cb51d8b3-8452-424b-8b70-21ebdf9c747a",
    defaultMessage: "Passed identity questions - Prepare Documents - Proof",
  },
  preMeetingIdentityQuestionsFailure: {
    id: "ac932527-1fa8-43e0-9b23-0d7068a3045c",
    defaultMessage: "Failed identity questions - Prepare Documents - Proof",
  },
  preMeetingIdentityQuestionsInfo: {
    id: "f76eda36-71d5-4d65-97af-342edb8d8714",
    defaultMessage: "Unable to generate identity questions - Prepare Documents - Proof",
  },
  preMeetingCredentialAnalysisIntro: {
    id: "e5e6db15-7903-45dd-ab16-97579721b638",
    defaultMessage: "Capture your ID - Prepare Documents - Proof",
  },
  preMeetingCredentialAnalysisSecondary: {
    id: "e07ca3fe-d2a2-4ca9-ac79-7bc7151dd1b2",
    defaultMessage: "Do you require a secondary ID? - Prepare Documents - Proof",
  },
  preMeetingCredentialAnalysisPhotoIdUpload: {
    id: "fb121709-f9f3-4bd9-91af-1a7836cb0794",
    defaultMessage: "Photo ID Upload - Prepare Documents - Proof",
  },
  preMeetingCredentialAnalysisCapture: {
    id: "9ccf1dab-d946-4031-bf87-6715c61be8e5",
    defaultMessage: "ID verification - Prepare Documents - Proof",
  },
  preMeetingCredentialAnalysisFailure: {
    id: "2812ac1e-40c0-4b10-bf09-4dc6fd5783b4",
    defaultMessage: "ID validation error - Prepare Documents - Proof",
  },
  preMeetingCosignerCustomerDetailsIntro: {
    id: "cbb4e235-fc24-4aaf-afe9-2914e0298da4",
    defaultMessage: "Next steps for cosigner ID verification - Prepare Documents - Proof",
  },
  preMeetingCosignerCustomerDetailsPersonalDetails: {
    id: "3feb4562-395d-4663-b8dc-4a6692734845",
    defaultMessage: "Enter cosigner information - Prepare Documents - Proof",
  },
  preMeetingCosignerCustomerDetailsAddressDetails: {
    id: "aaf737db-c3a7-4e07-9798-77d02d1069de",
    defaultMessage: "Enter cosigner address - Prepare Documents - Proof",
  },
  preMeetingCosignerIdentityQuestionsIntro: {
    id: "f16cc2fc-350d-483a-92a1-f4d43affb10e",
    defaultMessage: "Cosigner identity questions intro - Prepare Documents - Proof",
  },
  preMeetingCosignerIdentityQuestionsQuiz: {
    id: "d1f2923a-81ae-4438-815e-2f91809a89e5",
    defaultMessage: "Cosigner identity questions quiz - Prepare Documents - Proof",
  },
  preMeetingCosignerIdentityQuestionsSuccess: {
    id: "e1b3db67-b58e-4cd7-96aa-f4fa593ff1f4",
    defaultMessage: "Passed cosigner identity questions - Prepare Documents - Proof",
  },
  preMeetingCosignerIdentityQuestionsFailure: {
    id: "e25ad648-1ee2-4169-a3d2-d88c12c690d3",
    defaultMessage: "Failed cosigner identity questions - Prepare Documents - Proof",
  },
  preMeetingCosignerIdentityQuestionsInfo: {
    id: "fda5948b-9045-4d49-939f-a4f14569fabe",
    defaultMessage: "Unable to generate cosigner identity questions - Prepare Documents - Proof",
  },
  preMeetingCosignerCredentialAnalysisIntro: {
    id: "0a875ac9-8aff-47bc-96f9-3d29946197f6",
    defaultMessage: "Capture cosigner's ID - Prepare Documents - Proof",
  },
  preMeetingCosignerCredentialAnalysisSecondary: {
    id: "063c9a2f-2cbd-431b-bd56-0041b3d70baf",
    defaultMessage: "Does cosigner require a secondary ID? - Prepare Documents - Proof",
  },
  preMeetingCosignerCredentialAnalysisSecondaryCapture: {
    id: "1da87db9-d8b6-4167-912b-7192a22a491a",
    defaultMessage: "Cosigner secondary ID verificaton - Prepare Documents - Proof",
  },
  preMeetingCosignerCredentialAnalysisFailure: {
    id: "a1187104-bb36-4c34-b664-050944dbcfab",
    defaultMessage: "Cosigner ID validation error - Prepare Documents - Proof",
  },
  guestMobileLink: {
    id: "f013b6a2-b258-41c6-ad66-bb72078e99e5",
    defaultMessage: "Continue in the App - Prepare Document - Proof",
  },
  requestNotaryVideoMeetingCameraRequired: {
    id: "22bd5cac-fc84-43f4-a159-f8c36d74c186",
    defaultMessage: "Camera access required - Prepare Documents - Proof",
  },
  requestNotaryVideoMeeting: {
    id: "9c2c951e-e8b6-4722-8e6c-a042f9cdf22b",
    defaultMessage: "Request Notary Video Meeting - Prepare Documents - Proof",
  },
  notaryVideoCallLobby: {
    id: "a13cd919-42f8-4661-af53-6344a618414c",
    defaultMessage:
      "Notary Video Call Lobby - Request Notary Video Meeting - Prepare Documents - Proof",
  },
  notaryVideoCallLobbyWaitingForOthers: {
    id: "d7d449da-a25c-4313-ad69-176bfd5767af",
    defaultMessage:
      "Waiting for a notary - Request Notary Video Meeting - Prepare Documents - Proof",
  },
  notaryVideoCallLobbyUnavailableNotary: {
    id: "06ee8bfb-ef58-47ad-84ec-1db2cc8f16c8",
    defaultMessage:
      "No available notaries - Request Notary Video Meeting - Prepare Documents - Proof",
  },
  notaryVideoCallLobbyPhoneCallback: {
    id: "ae973fdb-07fe-466e-82c5-94ca97fbd0bc",
    defaultMessage:
      "We apologize for the wait - Request Notary Video Meeting - Prepare Documents - Proof",
  },
  notaryVideoCallLobbyNsaUnavailable: {
    id: "dc458e0c-8442-44ad-b2db-4d5cefec636a",
    defaultMessage:
      "Outside Notary Signing Agent hours - Request Notary Video Meeting - Prepare Documents - Proof",
  },
  notaryVideoCallLobbyMeetingAccepted: {
    id: "405a0a07-c67f-47ab-a1cd-6b25663a021c",
    defaultMessage: "Meeting accepted - Request Notary Video Meeting - Prepare Documents - Proof",
  },
  notaryVideoCallLobbyPhoneNotification: {
    id: "3228f92e-ef8b-477c-85f6-31e80618e32a",
    defaultMessage: "Phone notification - Request Notary Video Meeting - Prepare Documents - Proof",
  },
  notaryOnboarding: {
    id: "9de520c4-6ad3-400e-816a-6fa717462ecf",
    defaultMessage: "Notary Onboarding - Proof",
  },
  notaryVideoCallLobbyLobbyError: {
    id: "4a7cf310-a84a-46ca-a710-cbc264a27214",
    defaultMessage: "Session cancelled - Request Notary Video Meeting - Prepare Documents - Proof",
  },
  signerIdentityExpiredSession: {
    id: "724afe01-70d7-43d3-b105-f46976cc2a04",
    defaultMessage: "Expired session - Prepare Documents - Proof",
  },
  errorBoundary: {
    id: "c4a4cec5-bbe0-42df-961f-1fd5b9efd17c",
    defaultMessage: "Something went wrong - Proof",
  },
  meeting: {
    id: "ed705488-d8a1-49e9-b4c0-9fd4b9793813",
    defaultMessage: "Meeting - Proof",
  },
  meetingCompletePaymentFailed: {
    id: "583f82db-2fad-41fe-8ac5-971228a7a325",
    defaultMessage: "Payment Failed - Proof",
  },
  meetingCompleteSetupPayment: {
    id: "433c372b-6049-452f-a3d3-7f320b46a636",
    defaultMessage: "Setup Payment - Notarization Complete - Proof",
  },
  meetingCompleteShareDocuments: {
    id: "8e34df5a-b7ba-4b96-b7e5-33f7a443e63a",
    defaultMessage: "Share Documents - Notarization Complete - Proof",
  },
  meetingCompleteCreatePassword: {
    id: "4e6efe43-2eda-44be-9591-a3e594899131",
    defaultMessage: "Create Password - Notarization Complete - Proof",
  },
  documentDetailsSummary: {
    id: "5ff0d6d7-f8b4-43ed-8d61-9e8217ca1095",
    defaultMessage: "Summary - Document Details - Proof",
  },
  documentDetailsNotary: {
    id: "58d3126d-f915-4521-bb43-9bb9ba28c088",
    defaultMessage: "Notary - Document Details - Proof",
  },
  documentDetailsVideo: {
    id: "a0a03cbf-eb9f-4c89-ba2b-575f7c63db5e",
    defaultMessage: "Video - Document Details - Proof",
  },
  documentDetailsDocument: {
    id: "2a6d39ef-9551-4bf0-8228-92b6c9f7789f",
    defaultMessage: "Document - Document Details - Proof",
  },
  shareDocumentByEmail: {
    id: "767fd03c-ed80-41ce-af45-a7c8daedd1f8",
    defaultMessage: "Share documents by email - Proof",
  },
  // Settings
  settingsDefault: {
    id: "11b6b461-0929-4014-8448-0b0ed10af24f",
    defaultMessage: "Settings - Proof",
  },
  settingsOrganizationOverview: {
    id: "4e20745b-c7c1-4481-adce-5ef715736a1d",
    defaultMessage: "Organization Overview - Settings - Proof",
  },
  settingsSharedInbox: {
    id: "524bac2b-d9a0-4d7a-8275-67f0c0d133fc",
    defaultMessage: "Shared inbox - Settings - Proof",
  },
  settingsEligibility: {
    id: "486e981a-9202-4dca-a7d2-81aaea80fcd9",
    defaultMessage: "Eligibility - Settings - Proof",
  },
  settingsNotaryHours: {
    id: "733a416d-8414-429b-b7f1-5196eac0f462",
    defaultMessage: "Notary hours - Settings - Proof",
  },
  settingsBillingPlanDetails: {
    id: "7ba5c8c8-38b7-4a5e-a4c6-6c42c6d454a4",
    defaultMessage: "Plan Details - Billing - Settings - Proof",
  },
  settingsBillingPaymentSettings: {
    id: "fb138cc5-94d1-4bce-b85e-4092f76c603d",
    defaultMessage: "Payment Settings - Billing - Settings - Proof",
  },
  settingsBillingBillingContact: {
    id: "d3083695-7852-4749-9efa-26b8983053d5",
    defaultMessage: "Billing Contact - Billing - Settings - Proof",
  },
  settingsBillingRecentPayments: {
    id: "293a9e10-6e84-464f-aa24-fa4cd2d73a93",
    defaultMessage: "Recent Payments - Billing - Settings - Proof",
  },
  settingsTransactionsSignerSettings: {
    id: "c17ba4fc-b141-4f8f-aef9-54797fecabd1",
    defaultMessage: "Signer Settings - Transactions - Settings - Proof",
  },
  settingsTransactionsTemplateSettings: {
    id: "50fb4ade-7b09-411c-8902-723c5464e541",
    defaultMessage: "Template Settings - Transactions - Settings - Proof",
  },
  settingsTeamSecurity: {
    id: "47d539e6-2d3c-4fa3-a7ea-eb9f2e905890",
    defaultMessage: "Team security - Settings - Proof",
  },
  settingsBrandColors: {
    id: "8db17d53-bd8f-4f26-baf7-c0cbd6800d5b",
    defaultMessage: "Brand colors - Brand Customization - Settings - Proof",
  },
  settingsBrandLogoAndHeader: {
    id: "d5ad0361-8772-4c05-8c52-5d7ca8dbc125",
    defaultMessage: "Logo & header - Brand Customization - Settings - Proof",
  },
  settingsWebsiteCustomization: {
    id: "d3d147d0-f250-455f-b591-78a91bc7d6e5",
    defaultMessage: "Signer landing page - Website Customization - Settings - Proof",
  },
  settingsIntegrations: {
    id: "f221c2a1-dc96-4cbf-91b5-41ba69c5c85e",
    defaultMessage: "Integrations - Settings - Proof",
  },
  settingsApiKeys: {
    id: "4e220345-6359-4cb5-bb24-131e1900e16c",
    defaultMessage: "API keys - Settings - Proof",
  },
  settingsTransactionsNotaryInstructions: {
    id: "5295c7f3-e5ac-42e6-bec1-11c7bdab1ada",
    defaultMessage: "Notary Instructions - Transactions - Settings - Proof",
  },
  settingsProfileOverview: {
    id: "60dee205-c7d9-4cc7-b5da-587d4dc8b542",
    defaultMessage: "Profile Overview - Settings - Proof",
  },
  settingsProfilePersonalDetails: {
    id: "3dd2ef11-4d8f-43c3-8182-46ad8d4b69c6",
    defaultMessage: "Personal details - Profile - Settings - Proof",
  },
  settingsProfilePersonalPayments: {
    id: "dcf19966-afe7-4f1d-9c76-184cfddc24b0",
    defaultMessage: "Personal payment - Profile - Settings - Proof",
  },
  settingsProfilePersonalPaymentsUpdatePayment: {
    id: "569bda19-f3f2-48dc-bd6f-95910c4e71b1",
    defaultMessage: "Update payment method - Profile - Settings - Proof",
  },
  settingsProfilePersonalPaymentsPaymentDetails: {
    id: "51e0e92c-66f1-4d11-a812-7637f00625eb",
    defaultMessage: "Payment Detail - Profile - Settings - Proof",
  },
  settingsTerms: {
    id: "39e551be-118a-4a1c-996f-87267100ff96",
    defaultMessage: "Terms and conditions - Settings - Proof",
  },
  // Settings - Notary profile
  settingsNotaryDefault: {
    id: "6cb1d43c-32e7-421d-9438-31457faacacb",
    defaultMessage: "Notary profile - Settings - Proof",
  },
  settingsNotaryPersonalInfo: {
    id: "dc74d6a6-2c51-4b9d-b598-4db268c66ff9",
    defaultMessage: "Personal info - Notary profile - Settings - Proof",
  },
  settingsNotaryCommissionAndRonInfo: {
    id: "8c2d9e68-39ee-43e1-b5f3-147121e53269",
    defaultMessage: "Commission details - Notary profile - Settings - Proof",
  },
  settingsNotaryInsuranceDetails: {
    id: "d8a1e47f-0e2a-4918-bef7-2cc2e1aeb9e4",
    defaultMessage: "Insurance details - Notary profile - Settings - Proof",
  },
  settingsNotaryDigitalCertificate: {
    id: "2962e922-4189-4c66-9425-3744e58baaad",
    defaultMessage: "Digital certificate - Notary profile - Settings - Proof",
  },
  settingsNotarySignatureAndSeal: {
    id: "bd78f9ad-e274-47c2-b701-28243e52a6c3",
    defaultMessage: "Signature and seal - Notary profile - Settings - Proof",
  },
  settingsNotaryIdentityVerification: {
    id: "7b7f2cf8-687c-4b9f-96d7-6a66e44ffb33",
    defaultMessage: "Verify Identity - Notary profile - Settings - Proof",
  },
  settingsNotaryProofCertificate: {
    id: "f363641f-2b70-470d-8794-4c7b0d96d020",
    defaultMessage: "Proof certificate - Notary profile - Settings - Proof",
  },
  settingsNotaryPayoutOptions: {
    id: "76f38801-12d3-402f-a1a5-3187bf55c59d",
    defaultMessage: "Payout options - Notary profile - Settings - Proof",
  },
  settingsNotaryStateEducation: {
    id: "3832ac1d-a3e9-49a9-af84-bcdc34c3b63f",
    defaultMessage: "State education - Notary profile - Settings - Proof",
  },
  settingsNotaryTermsOfUse: {
    id: "5e2e183f-73cc-4f82-b7ee-c33b4d57af08",
    defaultMessage: "Terms - Notary profile - Settings - Proof",
  },
  notaryJournal: {
    id: "370da221-0db8-4ed6-9d7d-df9309c6af7f",
    defaultMessage: "Notary journal - Proof",
  },
  // errors
  mutationError: {
    id: "53dc99b9-f125-4fef-bb49-1f3f030bd8f4",
    defaultMessage: "Something went wrong - Proof",
  },
});
